export default __webpack_public_path__ + "static/media/rangeraction.305fafb8.png";